/**
 * @file Allows intl methods to be injected into Vue apps globally.
 * @intl-ignore
 */

import { PluginObject, VueConstructor } from 'vue'
import { n__, __, p__, np__, N__ } from 'bits/intl'

declare module 'vue/types/vue' {
  interface Vue {
    __: (phrase: string, args?: object) => string
    n__: (singularPhrase: string, pluralPhrase: string, num: number, args: object) => string
    p__: (context: string, phrase: string, args?: object) => string
    np__: (context: string, singularPhrase: string, pluralPhrase: string, num: number, args: object) => string
    N__: (phrase: string) => string
  }
}

const IntlPlugin: PluginObject<void> = {
  install: (Vue: VueConstructor): void => {
    Vue.prototype.__ = (phrase: string, args?: object): string => {
      return __(phrase, args)
    }

    Vue.prototype.n__ = (singularPhrase: string, pluralPhrase: string, num: number, args: object): string => {
      return n__(singularPhrase, pluralPhrase, num, args)
    }

    Vue.prototype.p__ = (context: string, phrase: string, args?: object): string => {
      return p__(context, phrase, args)
    }

    Vue.prototype.np__ = (
      context: string,
      singularPhrase: string,
      pluralPhrase: string,
      num: number,
      args: object,
    ): string => {
      return np__(context, singularPhrase, pluralPhrase, num, args)
    }

    Vue.prototype.N__ = (phrase: string): string => {
      return N__(phrase)
    }
  },
}

export default IntlPlugin
